import React from 'react';

import cs from 'classnames';
import moment from 'moment';
import { useRecoilValue } from 'recoil';

import { useNewAppointmentContext } from 'lib/context/Appointment/NewAppointmentContext';
import { iaRa } from 'lib/helpers/utility';

import { currentPractice } from 'components/practice/practiceState';

export default function TimeSlots({
  day,
  index,
  handleLoadMore,
  type = '',
  selectAppointmentLocation,
  appointmentLocation
}) {
  const slotVarType = type === 'location' ? 'locationAvailableSlots' : 'virtualAvailableSlots';
  const aptLocationVarType = type === 'location' ? 'in_person' : 'virtual';
  const practice = useRecoilValue(currentPractice);
  const { formik } = useNewAppointmentContext();

  const handleConvertTimesToPracticeTimezone = (hours = [], practiceTimezone) => {
    const userTimezone = moment.tz.guess();

    return iaRa(hours).map((timeStr) => {
      const timeInPracticeTZ = moment.tz(timeStr, 'hh:mm A', practiceTimezone);

      const timeInUserTZ = timeInPracticeTZ.clone().tz(userTimezone);

      return timeInUserTZ.format('hh:mm A');
    });
  };

  const handleClickSlot = (time) => {
    handleChangeTime(time);
    type === 'virtual' && selectAppointmentLocation({ label: 'Virtual', value: 'virtual' });
    type === 'location' && selectAppointmentLocation({ value: 'in_person', label: 'In-Person' });
  };

  const handleChangeTime = (time) => {
    const userTimezone = moment.tz.guess();

    const baseDate = moment.tz(formik.values.startsAt, userTimezone);

    const selectedTimeMoment = moment.tz(time, 'hh:mm A', userTimezone);
    baseDate.set({
      hour: selectedTimeMoment.hour(),
      minute: selectedTimeMoment.minute(),
      second: 0,
      millisecond: 0
    });

    formik.setFieldValue('startsAt', baseDate.toDate());
  };

  const RenderSlots = () => {
    return handleConvertTimesToPracticeTimezone(
      day[slotVarType].slice(0, day.showAll ? day[slotVarType].length : 4),
      practice?.timezone
    ).map((i, idx) => {
      console.log({
        original: formik.values.startsAt,
        localTime: moment(formik.values.startsAt).tz(moment.tz.guess()).format('hh:mm A'),
        practiceTime: moment(formik.values.startsAt).tz(practice?.timezone).format('hh:mm A')
      });

      return (
        <div
          className={cs(
            'grid h-10 cursor-pointer place-content-center rounded-md border border-solid bg-white text-sm',
            moment(formik.values.startsAt).tz(moment.tz.guess()).format('hh:mm A') == i &&
              appointmentLocation === aptLocationVarType
              ? '!border-neutral-800 !text-neutral-800'
              : 'border-neutral-100 text-neutral-500'
          )}
          key={i}
          onClick={() => handleClickSlot(i)}>
          <p>{i}</p>
        </div>
      );
    });
  };

  return (
    <div className="!mt-[15px]">
      <label className="block pb-1 text-sm font-500">
        Select from available time slots for {type}
      </label>

      <div className="grid grid-cols-5 !gap-3">
        <RenderSlots />

        {!day.showAll && day[slotVarType].length > 4 && (
          <div
            onClick={() => handleLoadMore({ index })}
            className={cs(
              'grid h-10 cursor-pointer place-content-center rounded-md border border-solid border-neutral-100 bg-white text-sm text-neutral-500 hover:!border-neutral-800 hover:text-neutral-800'
            )}>
            <p>Load All</p>
          </div>
        )}
      </div>
    </div>
  );
}
